import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '@core/authentication';
import { mergeMap, of } from 'rxjs';

export const AuthGuardFn: CanMatchFn = () => {
  const router = inject(Router);

  return inject(AuthService)
    .getAccount()
    .pipe(
      mergeMap(account => {
        if (!account) {
          return of(router.parseUrl('/login'));
        }

        const isLocked = (account?.idTokenClaims?.extension_GuPortalIsLockedValue as number) ?? 0;
        if (isLocked === 2) {
          return of(router.parseUrl('/sessions/locked'));
        }

        const contractorNumber = account?.idTokenClaims?.extension_ContractorNumber;
        if (!contractorNumber || contractorNumber === '' || isLocked === 1) {
          return of(router.parseUrl('/register/contractor'));
        }

        return of(true);
      })
    );
};
